import { useDemoModal } from "./DemoModal";

// Shared pricing tiers (Free, Team, Enterprise) used by both the /pricing page and the
// landing #pricing section. Pro was removed and its key features merged into Team.
export default function PricingTiers() {
  const { openDemoModal } = useDemoModal();
  return (
    <div className="tiers reveal">
      <div className="tier feature">
        <div className="badge">Start free · no card</div>
        <h3>Free</h3>
        <div className="price">$0</div>
        <div className="per">your first 5 hours of calls, on us</div>
        <ul>
          <li>Live assist on your calls: the answer the moment you need it</li>
          <li>Auto-capture and follow-up drafts after every call</li>
          <li>Runs natively on your Mac, on any call platform</li>
          <li>No credit card to get started</li>
        </ul>
        <button className="btn btn-dark" onClick={() => openDemoModal({ context: "Free tier" })}>Book a demo</button>
      </div>
      <div className="tier">
        <div className="badge" style={{ color: "var(--gray-4)" }}>For teams of 5 to 50 reps</div>
        <h3>Team</h3>
        <div className="price" style={{ fontSize: "28px", paddingTop: "10px" }}>Let's talk</div>
        <div className="per">priced per seat, annual or monthly</div>
        <ul>
          <li>Everything in Free</li>
          <li>First access to every agent as it ships, weekly cadence</li>
          <li>Direct Slack channel with the founders</li>
          <li>Shared team graph: plays, objections, and answers across every rep</li>
          <li>CRM auto-update and team onboarding</li>
          <li>Admin controls and usage analytics</li>
        </ul>
        <button className="btn btn-ghost" onClick={() => openDemoModal({ context: "Team tier" })}>Talk to us</button>
      </div>
      <div className="tier">
        <div className="badge" style={{ color: "var(--gray-4)" }}>2027 · <span className="chip future">roadmap</span></div>
        <h3>Enterprise</h3>
        <div className="price" style={{ fontSize: "28px", paddingTop: "10px" }}>Custom</div>
        <div className="per">for revenue orgs with security teams</div>
        <ul>
          <li>SSO and SAML, role-based access control</li>
          <li>PII redaction, audit logs, retention policies</li>
          <li>Coaching Staff and Intelligence Desk</li>
          <li>Dedicated deployment support</li>
        </ul>
        <button className="btn btn-ghost" onClick={() => openDemoModal({ context: "Enterprise" })}>Get on the list</button>
      </div>
    </div>
  );
}
